import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from '../../../hook/use-http';
import moment from 'moment';
import { ThreeCircles } from 'react-loader-spinner';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';

const TOP_KPIS_FIRST_PAGE = {
  chassi_number: "--",
  city: "--",
  lob: "--",
  ppl: "--",
  vehicle_registration_number: "--",
};

function TopkpisSecond_Orion({ gloablfilter, apiend }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result[0];
      responce = {
        chassi_number: temp_result['_source'].vehicleId,
        city: temp_result['_source'].DLR_ORG_CITY,
        lob: temp_result['_source'].LOB,
        ppl: temp_result['_source'].PPL,
        vehicle_registration_number: temp_result['_source'].vehicle_registration_number,
        PL: temp_result['_source'].PL,
        Depot_Name: temp_result['_source'].Depot_Name
      }
      setTopData((prestate) => responce);
    } else {
      setTopData((prestate) => TOP_KPIS_FIRST_PAGE);
    }

  }


  useEffect(() => {

    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)

  return (
    <>
      <section className="headBG my-2 p-2">
        <div className="row d-flex align-items-center">
          <div className="col-md-3"><strong>Chassis No:</strong>
            {isLoading ? loader : (topdata.chassi_number)}
          </div>
          {/* <div className="col-md-1"><strong>City:</strong>
            {isLoading ? loader : (topdata.city)}
          </div> */}
          <div className="col-md-1"><strong>LOB:</strong>
            {isLoading ? loader : (topdata.lob)}
          </div>
          <div className="col-md-2"><strong>PPL:</strong>
            {isLoading ? loader : (topdata.ppl)}
          </div>
          <div className="col-md-2"><strong>PL:</strong>
            {isLoading ? loader : (topdata.PL)}
          </div>
          {/* <div className="col-md-1"><strong>DEPOT:</strong>
            {isLoading ? loader : (topdata.Depot_Name)}
          </div> */}
          <div className="col-md-2"><strong>Reg No.:</strong>
            {isLoading ? loader : (topdata.vehicle_registration_number)}
          </div>
        </div>
      </section>
    </>
  )

}
export default TopkpisSecond_Orion;
